import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import BookingItem from "../booking_room/BookingItem";
import { notify } from "../common/Toast";

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      setError(null);
      const response = await ApiService.getUserProfile();
      if (!response) {
        notify("Session expired. Please log in again.", "error");
        ApiService.logout();
        navigate("/home");
      }
      const userPlusBookings = await ApiService.getUserBookings(response.id);
      setUser(userPlusBookings);
    };
    fetchUserProfile();
  }, [navigate]);

  const handleLogout = () => {
    ApiService.logout();
    navigate("/home");
  };

  const handleEditProfile = () => {
    navigate("/edit-profile");
  };

  return (
    <div className="profile-page">
      {user && <h2>Welcome, {user.name}</h2>}
      <div className="profile-actions">
        <button className="edit-profile-button" onClick={handleEditProfile}>
          {" "}
          Edit Profile{" "}
        </button>
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </div>
      {error && <p className="error-message">{error}</p>}
      {user && (
        <div className="profile-details">
          <h3>My Profile Details</h3>
          <p>
            <strong>Email: </strong> {user.email}
          </p>
          <p>
            <strong>Phone Number: </strong> {user.phoneNumber}
          </p>
        </div>
      )}
      <div className="bookings-section">
        <h3>My Booking History</h3>
        <div className="booking-list">
          {user && user.bookings.length > 0 ? (
            user.bookings.map((booking) => (
              <BookingItem bookingDetails={booking} key={booking.id} />
            ))
          ) : (
            <p>No bookings found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
